var map = {
	"./classic/checkout_error.m4a": 79383,
	"./classic/checkout_success.m4a": 627,
	"./future/checkout_error.m4a": 87360,
	"./future/checkout_success.m4a": 97406,
	"./modern/checkout_error.m4a": 56682,
	"./modern/checkout_success.m4a": 84047
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16070;